module.exports = {
  // devServer: {
  //   proxy: {
  //     '/api': {
  //       target: 'http://localhost:37496/api',
  //       ws: false,
  //       changeOrigin: true
  //     }
  //   },
  //   open: true,
  //   host: 'localhost',
  //   port: 8090
  // },
  devServer: {
    proxy: {
      '/api': {
        target: 'https://parking.yundiankong.com/api',
        ws: false,
        changeOrigin: true,
        pathRewrite: {
          '^/api': ''
        }
      }
    },
    open: true,
    host: 'pay.yundiankong.com',
    port: 80
  },
}
